export default "__VITE_ASSET__CfhPElNJ__"